import React from "react";
import Success from "../../assets/assets/Groupsuccess.svg";
import { PropTypes } from 'prop-types';

const Modal = (props) => {
  return (
    <div className="success-modal-body">
      <div className="modal-image">
        <img src={Success} alt="icon" />
      </div>
      <h3>Demo Schedule Successful</h3>
      <p>
        A mail has been sent to you with your demo
        <br />
        schedule details
      </p>
      <div className="modal-btn">
        <button onClick={() => props.click()}>continue</button>
      </div>
    </div>
  );
};

Modal.propTypes = {
  click: PropTypes.func
}

export default Modal;
